import { DHLError, axiosRequest, getCurrentDate, handleHttpResponse } from '@general/js/utils';
import { Services } from '../Services';

export default class PremiumImpactServices {
  /**
   * Retrieves the premium adjustment prices and dates for the Premium Adjustment timeline
   * @param {string} memberNumber member number or policy number
   * @param {boolean} showPremiumPaymentAmount whether the premium payment amount is to be included in response
   * @param {string} currentDate date in 'yyyy-mm-dd' format (optional)
   * @returns
   */
  static async getPremiumAdjustmentPrices(memberNumber, showPremiumPaymentAmount, currentDate = getCurrentDate()) {
    try {
      const response = await axiosRequest().get(Services.PREMIUM_IMPACT.GET_PREMIUM_ADJUSTMENT_PRICES(memberNumber, showPremiumPaymentAmount, currentDate));
      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getPremiumAdjustmentPrices() - Call failed with error`);
    }
  }
}
